import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trophy } from "@phosphor-icons/react";
import api from "@/lib/api";
import { BTN_BLACK, BTN_WHITE, errText } from "@/components/pageSettings/AdminModal";

const needsLook = (t) => t && (t.status === "pending" || (t.status === "finished" && !t.notice_seen));

function NoticeRow({ item, busy, onAct }) {
  const pending = item.status === "pending";
  const where = item.buyer ? ` for ${item.firm_name || item.buyer}` : "";
  const target = item.buyer ? "their thank-you page" : `your default thank-you design${item.scope === "all" ? " on every page" : ""}`;
  const id = item.page_id ? `ty-test-notice-${item.page_id}` : "ty-test-notice";
  return (
    <div className="flex flex-wrap items-center gap-3 border-2 border-black bg-emerald-50 p-3" data-testid={id}>
      <Trophy size={20} weight="bold" />
      <p className="mr-auto text-sm" data-testid={`${id}-text`}>
        Thank-you test{where}: <b>{item.winner_name}</b> {pending ? "has the best tap rate and is waiting for your approval." : `won and is now ${target}.`}
      </p>
      {pending && <button type="button" className={BTN_BLACK} disabled={busy} onClick={() => onAct(item, "/approve", "Winner switched on")} data-testid={`${id}-approve`}>Approve the switch</button>}
      <Link to="/admin/landing-pages" className={BTN_WHITE} data-testid={`${id}-open`}>See the stats</Link>
      {!pending && <button type="button" className={BTN_WHITE} disabled={busy} onClick={() => onAct(item, "/seen")} data-testid={`${id}-dismiss`}>Got it</button>}
    </div>
  );
}

// Dashboard notes when the overall or a buyer's thank-you test finds a winner.
export function ThankYouTestNotice() {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => Promise.all([api.get("/admin/thankyou-test"), api.get("/admin/thankyou-buyer-tests", { params: { attention: 1 } })])
    .then(([o, b]) => setItems([...(needsLook(o.data) ? [o.data] : []), ...b.data.tests]))
    .catch(() => {});
  useEffect(() => { load(); }, []);
  const onAct = async (item, path, msg) => {
    setBusy(true);
    try {
      await api.post(`${item.page_id ? `/thankyou-tests/page/${item.page_id}` : "/admin/thankyou-test"}${path}`);
      if (msg) toast.success(msg);
      await load();
    } catch (e) {
      toast.error(errText(e, "Couldn't update the test"));
    } finally {
      setBusy(false);
    }
  };
  if (!items.length) return null;
  return <div className="mb-6 space-y-2">{items.map((i) => <NoticeRow key={i.page_id || "overall"} item={i} busy={busy} onAct={onAct} />)}</div>;
}
